import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import FeedbackQuestionForm from '../../forms/FeedbackQuestion';

import { hideElementForNonAdmins, spaceAndCapitalize } from '../../utilities/Forms.js'

import { faCheckCircle, faTimes, faArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SlidingPane from "../../components/shared/ScrollableSlidingPane";

import { DragDropContext, Draggable  } from 'react-beautiful-dnd';
import Droppable from '../../components/shared/StrictModeDroppable'

import HelpText from '../../components/help/HelpText';
import { request, handleRequestErrors } from '../../helpers/Requests'

class ListOfFeedbackQuestions extends Component {
  constructor(props) {
    super(props);

    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.handleEditPanel = this.handleEditPanel.bind(this);
    this.closeEditPanel = this.closeEditPanel.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  state = {
    feedbackQuestions: [],
    loaded: false,
    error: null,

    questionId: null,
    newPanelToggle: false,
    editPanelToggle: false,
    unauthorized: ""
  };

  handleNewPanel(event) {
    this.setState({newPanelToggle: true});
    this.props.history.push(`/configuration/feedback/${this.props.feedback_id}/question/new`)
  }

  handleEditPanel(event) {
    let questionId = event.currentTarget.id;

    this.setState({questionId: questionId});
    this.setState({editPanelToggle: true});
    this.props.history.push(`/configuration/feedback/${this.props.feedback_id}/question/${questionId}`)
  }

  closeEditPanel() {
    this.setState({ editPanelToggle: false });
    this.setState({ questionId: null });
    this.props.history.push(`/configuration/feedback/${this.props.feedback_id}`);
    this.componentDidMount();
  }

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const parent_question_id = result.source.droppableId.split("#")[1]

    const questions = this.state.feedbackQuestions.filter(feedbackQuestion => feedbackQuestion.depends_on_question_id?.toString() === parent_question_id)
    const otherQuestions = this.state.feedbackQuestions.filter(feedbackQuestion => feedbackQuestion.depends_on_question_id?.toString() !== parent_question_id)

    const feedbackQuestions = this.reorder(
      questions,
      result.source.index,
      result.destination.index
    );

    let orderLookup = this.findOrderLookup(feedbackQuestions.concat(otherQuestions))

    this.setState({
      feedbackQuestions: feedbackQuestions.concat(otherQuestions),
      orderLookup: orderLookup,
      lastQuestionInTable: this.findLastQuestionInTable(orderLookup)
    });

    var reorderList = []
    for (var i = 0; i < feedbackQuestions.length; i++) {
      reorderList.push({id: feedbackQuestions[i].id, order: feedbackQuestions[i].order})
    }

    var json = JSON.stringify({
      "feedback_questions": {
        "reorder": reorderList
      }
    })

    request("POST", `/v1/a/feedback_questions/reorder`, json, () => {this.setState({unauthorized: true})})
      .catch(error => handleRequestErrors(this, error))
  }

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    // now, reassign feedbackQuestions.order numbers
    var newResult = []
    for (var i = 0; i < result.length; i++) {
      var feedbackQuestions = result[i]
      feedbackQuestions.order = i + 1

      newResult.push(feedbackQuestions)
    }

    return newResult;
  };

  indexBackground(index) {
    if (index % 2 === 0) {
      return "#eee"
    }
    else {
      return "#fff"
    }
  }

  answerType(answer_type) {
    if (answer_type === "boolean") {
      return "Yes/No"
    }

    if (answer_type === "net_promoter") {
      return spaceAndCapitalize(answer_type)
    }

    return spaceAndCapitalize(answer_type, "-")
  }

  helpSection() {
    if (this.props.disabled) {
      return 'static-questions'
    }
    else {
      return 'questions'
    }
  }

  renderNewButton() {
    if (!this.props.disabled) {
      return (
        <Link to={`/configuration/feedback/${this.props.feedback_id}/question/new`} onClick={this.handleNewPanel} id={this.props.feedback_id}>
          <div className={`button new-button ${hideElementForNonAdmins()}`}>New Feedback Question</div>
        </Link>
      )
    }
  }

  renderQuestionsWithFollowOns(parent_id = null) {
    const feedbackQuestions = this.state.feedbackQuestions.filter(feedbackQuestion => feedbackQuestion.depends_on_question_id === parent_id)

    if (feedbackQuestions.length === 0) {
      return
    }

    const getItemStyle = (isDragging, draggableStyle, index) => ({
      backgroundColor: isDragging ? "lightgreen" : this.indexBackground(index),
      ...draggableStyle
    });

    const { disabled, feedback_id } = this.props;
    return (
      <DragDropContext onDragEnd={this.onDragEnd} className="table big-table">
        <Droppable droppableId={parent_id ? `droppable#${parent_id}` : "droppable"}>
          {(provided, snapshot) => (
            <div {...provided.droppableProps} className="drag-and-drop" ref={provided.innerRef} >
              {feedbackQuestions.map((feedbackQuestion, index) => (
                <Draggable key={`key-${feedbackQuestion.id}`} draggableId={`key-${feedbackQuestion.id}`} index={index} isDragDisabled={disabled}>
                  {(provided, snapshot) => {
                    if (snapshot.isDragging) {
                      provided.draggableProps.style.left = "32px"
                    }
                    const nested = this.state.lastQuestionInTable === feedbackQuestion.id ? "" : "nested ";
                    return (
                      <>
                        <Link to={`/configuration/feedback/${feedback_id}/question/${feedbackQuestion.id}`} onClick={this.handleEditPanel} id={feedbackQuestion.id} feedbackid={feedback_id} className={`${nested}row eight-columns${disabled ? " disabled" : ""}`} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style, index)} >
                          {!disabled && <div className={`td${this.colourDragger(this.state.orderLookup[feedbackQuestion.id])}`}><FontAwesomeIcon icon={faArrowsAlt} /></div>}
                          <div className="td">{this.state.orderLookup[feedbackQuestion.id]}</div>
                          <div className="td">{feedbackQuestion.name}</div>
                          <div className="td">{feedbackQuestion.display}</div>
                          <div className="td">{feedbackQuestion.ask_condition}</div>
                          <div className="td center">{this.answerType(feedbackQuestion.answer_type)}</div>
                          <div className="td center">{feedbackQuestion.hidden ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faTimes} />}</div>
                          <div className="td center">{feedbackQuestion.has_active_alert ? <FontAwesomeIcon icon={faCheckCircle} /> : <FontAwesomeIcon icon={faTimes} />}</div>
                        </Link>
                        {this.renderQuestionsWithFollowOns(feedbackQuestion.id)}
                      </>
                    )
                  }}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }

  colourDragger(prefix) {
    const depth = prefix.split(".")

    if (depth.length === 1) {
      return ""
    }

    switch (depth.length % 3) {
    case 1:
      return " blue-text"
    case 2:
      return " red"
    case 0:
      return " green-text"
    default:
      return ""
    }
  }

  render() {
    const { feedbackQuestions, orderLookup, loaded, error, unauthorized } = this.state;
    const { disabled } = this.props;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      let feedback_id = this.props.feedback_id;

      return (
        <div className="section">
          <HelpText page={'feedbackType'} section={this.helpSection()} />
          <h3 className="inline-block">List of Feedback Questions</h3>

          {this.renderNewButton()}
          <div className="seperator"> </div>

          <div className="drag-and-drop" >
            <div className={`nested row eight-columns heading${disabled ? " disabled" : ""}`}>
              {!disabled && <div className="th"></div>}
              <div className="th">Order</div>
              <div className="th">Name</div>
              <div className="th">Question</div>
              <div className="th">Ask Condition</div>
              <div className="th">Answer Type</div>
              <div className="th">Hidden</div>
              <div className="th">Has Active Alert</div>
            </div>
            {this.renderQuestionsWithFollowOns()}
          </div>

          <SlidingPane isOpen={this.state.newPanelToggle} title="New Feedback Question" width="70%"
            onRequestClose={() => {
              this.setState({ newPanelToggle: false });
              this.props.history.push(`/configuration/feedback/${feedback_id}`);
              this.componentDidMount();
            }}>
            <FeedbackQuestionForm mode="create" feedbackQuestions={feedbackQuestions} orderLookup={orderLookup} feedback_type_id={this.props.feedback_id} />
          </SlidingPane>

          <SlidingPane isOpen={this.state.editPanelToggle} title="Edit Feedback Question" width="70%"
            onRequestClose={() => {
              this.closeEditPanel()
            }}>
            <FeedbackQuestionForm feedbackQuestions={feedbackQuestions} orderLookup={orderLookup} feedback_type_id={this.props.feedback_id} id={this.state.questionId} closePanel={this.closeEditPanel} disabled={this.props.disabled} />
          </SlidingPane>

        </div>
      );
    }
  }

  static getDerivedStateFromProps(props, state) {
    let question_id = props.match.params.question_id
    if (state.newPanelToggle && question_id !== null && question_id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        questionId: question_id
      }
    }
    if (state.editPanelToggle && (question_id === null || question_id === undefined)) {
      return {
        editPanelToggle: false
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.history.location.pathname.endsWith(`/feedback/${props.feedback_id}`)) {
      return {
        newPanelToggle: false,
        editPanelToggle: false,
        questionId: null
      }
    }
    else if (props.history.action === "POP" && props.history.location.pathname.endsWith("/question/new")) {
      return {
        newPanelToggle: true,
        editPanelToggle: false,
        questionId: null
      }
    }
    else if (props.history.action === "POP" && question_id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        questionId: question_id
      }
    }
    else {
      return null
    }
  }

  findOrderLookup(feedbackQuestions, lookupTable = {}, id = null, prefix = "") {
    const questionsToIterate = feedbackQuestions.filter(question => question.depends_on_question_id === id)
    questionsToIterate.forEach(question => {
      const order = prefix ? `${prefix}.${question.order}` : question.order.toString()
      lookupTable[question.id] = order
      this.findOrderLookup(feedbackQuestions, lookupTable, question.id, order)
    })

    return lookupTable
  }

  findLastQuestionInTable(order) {
    const values = Object.values(order)
    if (values.length === 0) {
      return
    }

    const highestOrderValue = values.sort()[values.length -1]

    return parseInt(Object.entries(order).find(entry => entry[1] === highestOrderValue)[0])
  }

  componentDidMount() {
    // deep linking
    if (this.props.location.pathname.endsWith("question/new") && this.state.newPanelToggle === false) {
      this.setState({
        newPanelToggle: true
      });
    }
    else if (this.props.question_id !== null && this.props.question_id !== undefined && this.state.editPanelToggle === false) {
      this.setState({
        questionId: this.props.question_id,
        editPanelToggle: true
      });
    }

    // normal API fetching stuff
    let feedback_id = this.props.feedback_id;

    request("GET", `/v1/a/feedback_types/${feedback_id}/feedback_questions`, "", () => {this.setState({unauthorized: true})})
      .then(data => {
        const orderLookup = this.findOrderLookup(data)
        this.setState({
          feedbackQuestions: data,
          orderLookup: orderLookup,
          lastQuestionInTable: this.findLastQuestionInTable(orderLookup),
          loaded: true
        })
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default withRouter(ListOfFeedbackQuestions);
